/* VELORUS Aura™ PDP runtime — gallery, FAQ, sticky bar, add to cart, marquee,
   survey bars, header drawer. Vanilla, no dependencies. Every click handler is
   delegated from document, so sections re-rendered by the theme editor keep
   working without re-binding. */
if (!window.AURA) {
  window.AURA = {};
  (function () {
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ------------------------------------------------------------ i18n */
    function t(key, fallback) {
      var el = $('[data-aura-i18n]');
      if (el && !el._aura) { try { el._aura = JSON.parse(el.textContent); } catch (e) { el._aura = {}; } }
      return (el && el._aura && el._aura[key]) || fallback;
    }

    /* --------------------------------------------------------- gallery */
    function galleryState(root) {
      var product = root.closest('[data-aura-product]') || document;
      return {
        root: product,
        slides: $$('[data-aura-slide]', product),
        thumbs: $$('[data-aura-thumb]', product),
        counter: $('[data-aura-counter]', product)
      };
    }
    function showImage(g, i) {
      var n = g.slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      g.root._auraImg = i;
      g.slides.forEach(function (s, k) { s.hidden = k !== i; });
      if (g.counter) g.counter.textContent = (i + 1) + ' / ' + n;
      /* The 5-thumb window: start = clamp(active − 2, 0, total − 5). */
      var start = Math.min(Math.max(0, i - 2), Math.max(0, n - 5));
      g.thumbs.forEach(function (b, k) {
        b.hidden = k < start || k > start + 4;
        var on = k === i;
        b.style.border = on ? '2px solid var(--aura-blue)' : '1px solid #DFE6EC';
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }
    function current(g) { return g.root._auraImg || 0; }

    function initSwipe(stage) {
      if (stage._auraSwipe) return;
      stage._auraSwipe = true;
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var g = galleryState(stage);
        showImage(g, current(g) + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* ------------------------------------------------------------- FAQ */
    function setFaq(q, open) {
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      var a = document.getElementById(q.getAttribute('aria-controls'));
      if (a) a.hidden = !open;
      var sign = $('[data-aura-faq-sign]', q);
      if (sign) sign.textContent = open ? '−' : '+';
    }
    function toggleFaq(q) {
      var wasOpen = q.getAttribute('aria-expanded') === 'true';
      var group = q.closest('[data-aura-faq]') || document;
      $$('[data-aura-faq-q]', group).forEach(function (o) { setFaq(o, false); });
      if (!wasOpen) setFaq(q, true);
    }

    /* ----------------------------------------------------------- toast */
    function notify(msg, withLink) {
      var box = $('[data-aura-toast]');
      if (!box) { window.alert(msg); return; }
      $('[data-aura-toast-text]', box).textContent = msg;
      var link = $('[data-aura-toast-link]', box);
      if (link) link.hidden = !withLink;
      box.hidden = false;
      clearTimeout(box._auraTimer);
      box._auraTimer = setTimeout(function () { box.hidden = true; }, 5000);
    }

    /* ------------------------------------------------------------ cart */
    function setCount(n) {
      $$('[data-aura-cart-count]').forEach(function (e) {
        e.textContent = ' (' + n + ')';
        e.hidden = !n;
      });
    }

    function addToCart(form, btn) {
      /* Take the last run of digits, so a gid:// or an admin URL still works.
         Empty means nothing sellable: refuse rather than guess another variant. */
      var raw = (btn.getAttribute('data-aura-variant') || '').trim();
      var digits = raw.match(/\d+/g);
      var id = digits ? digits[digits.length - 1] : '';
      if (!id) { notify('Produktas neprijungtas: nėra parduodamo varianto.'); return; }

      var after = btn.getAttribute('data-aura-after') || 'cart';
      var themeCart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var useTheme = after === 'drawer' && themeCart && typeof themeCart.renderContents === 'function' &&
                     typeof themeCart.getSectionsToRender === 'function';

      var body = { items: [{ id: Number(id), quantity: 1 }] };
      if (useTheme) {
        body.sections = themeCart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      var label = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = t('loading', 'Dedama…');

      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      }).then(function (res) {
        if (!res.ok) { notify(res.data.description || res.data.message || t('error', 'Nepavyko įdėti į krepšelį.')); return; }

        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); })
          .catch(function () {});

        if (after === 'cart') { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; return; }

        if (useTheme) {
          /* Dawn/Sense's own drawer or notification, fed the way its own
             product-form feeds it. Not combined with the events below, or a
             cart app and the theme cart open at the same time. */
          var item = (res.data.items && res.data.items[0]) || {};
          var state = Object.assign({}, item, { sections: res.data.sections });
          try { themeCart.renderContents(state); } catch (e) { notify(t('added', 'Įdėta į krepšelį'), true); }
          if (themeCart.classList && themeCart.classList.contains('is-empty')) themeCart.classList.remove('is-empty');
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
        notify(t('added', 'Įdėta į krepšelį'), true);
      }).catch(function () {
        notify(t('error', 'Nepavyko įdėti į krepšelį. Bandykite dar kartą.'));
      }).then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = label;
      });
    }

    /* ---------------------------------------------------------- drawer */
    function setDrawer(open) {
      var d = $('[data-aura-drawer]');
      if (!d) return;
      d.hidden = !open;
      $$('[data-aura-burger]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var c = $('.aura-drawer__close', d); if (c) c.focus(); }
    }

    /* -------------------------------------------------------- wiring */
    document.addEventListener('click', function (e) {
      var tg = e.target;
      if (!tg.closest) return;
      var el;
      if ((el = tg.closest('[data-aura-thumb]'))) { showImage(galleryState(el), Number(el.getAttribute('data-aura-thumb'))); return; }
      if ((el = tg.closest('[data-aura-prev]'))) { var g1 = galleryState(el); showImage(g1, current(g1) - 1); return; }
      if ((el = tg.closest('[data-aura-next]'))) { var g2 = galleryState(el); showImage(g2, current(g2) + 1); return; }
      if ((el = tg.closest('[data-aura-faq-q]'))) { toggleFaq(el); return; }
      if ((el = tg.closest('[data-aura-burger]'))) { setDrawer(true); return; }
      if ((el = tg.closest('[data-aura-drawer-close]'))) { setDrawer(false); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.aura-form')) return;
      e.preventDefault();
      var btn = $('[data-aura-add]', form);
      if (btn && !btn.disabled) addToCart(form, btn);
    });

    /* ------------------------------------------------- sticky + bars */
    var io;
    function initSticky() {
      var bar = $('[data-aura-sticky]');
      var main = $('[data-aura-main-atc]');
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      var watched = [main].concat($$('[data-aura-final-atc]'));
      var inView = new Map();
      var passed = false;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView.set(en.target, en.isIntersecting);
          /* Shown only once the buy-box button has left through the top. */
          if (en.target === main && !en.isIntersecting) passed = en.boundingClientRect.top < 0;
        });
        var anyVisible = watched.some(function (w) { return inView.get(w); });
        var show = passed && !anyVisible;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      watched.forEach(function (w) { io.observe(w); });
    }

    function initBars() {
      var bars = $$('[data-aura-bar]');
      if (!bars.length || reduced || !('IntersectionObserver' in window)) return;
      bars.forEach(function (b) {
        if (b._aura) return;
        b._aura = true;
        b.style.transition = 'none';
        b.style.width = '0%';
        void b.offsetWidth;
        b.style.transition = '';
      });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.style.width = en.target.getAttribute('data-aura-bar') + '%';
          obs.unobserve(en.target);
        });
      }, { threshold: 0.4 });
      bars.forEach(function (b) { obs.observe(b); });
    }

    /* Lazy images inside aspect-ratio boxes that some mobile browsers never
       start loading: force any still-empty one within two viewports. */
    function rescueLazy() {
      var h = window.innerHeight * 2;
      $$('.aura img[loading="lazy"]').forEach(function (img) {
        if (img.complete && img.naturalWidth) return;
        if (img.closest('[hidden]')) return;
        var r = img.getBoundingClientRect();
        if (r.top < h && r.bottom > -h) { img.removeAttribute('loading'); var s = img.src; img.src = ''; img.src = s; }
      });
    }

    function init() {
      $$('[data-aura-stage]').forEach(initSwipe);
      initSticky();
      initBars();
    }

    var rescueTick;
    window.addEventListener('scroll', function () {
      clearTimeout(rescueTick);
      rescueTick = setTimeout(rescueLazy, 250);
    }, { passive: true });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  })();
}
